// extracted by mini-css-extract-plugin
export default {"kpiCard":"KPICards_kpiCard__oymRg","cardBody":"KPICards_cardBody__rm5Ml","kpiValue":"KPICards_kpiValue__ssrCz","kpiTitle":"KPICards_kpiTitle__waeRl"};